module.exports = __webpack_public_path__ + "static/vr-1-2-301089b961526642b58d72a041bcda2e.jpeg";